import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RateLimitService } from '../shared/services/rate-limit.service';

@Component({
  selector: 'app-pagina-externa',
  templateUrl: './pagina-externa.component.html',
  styleUrls: ['./pagina-externa.component.scss']
})
export class PaginaExternaComponent implements OnInit, OnDestroy {
  rateLimitActive = false;
  private rateLimitSubscription: Subscription;

  constructor(private rateLimitService: RateLimitService) { }

  ngOnInit(): void {
    // Suscribirse al estado del rate limit
    this.rateLimitSubscription = this.rateLimitService.rateLimitState$.subscribe(
      state => {
        this.rateLimitActive = state.isActive && state.timeRemaining > 0;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.rateLimitSubscription) {
      this.rateLimitSubscription.unsubscribe();
    }
  }

}
